import React, { useRef } from 'react'
import { TextField, makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import SydButton from '../../../commonDesign/Button'
import RoundedModal from '../../../molecules/RoundedModal'

const useStyles = makeStyles((theme) => ({
  form: {
    margin: '10px 0 50px',
    display: 'flex',
    flexDirection: 'column',
    gap: '50px'
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    gap: '20px'
  }
}))

function RunDialog ({ item, open, onCancel, onConfirm, processing }) {
  const classes = useStyles()
  const asOfDateRef = useRef()

  return (
    <RoundedModal
      title={`Run ${item.reportType}`}
      open={open}
      onClose={onCancel}
      position='top'
    >
      <div className={classes.dialogBody}>
        <div className={classes.form}>
          <div>As-of (Leave blank for latest)</div>
          <TextField inputRef={asOfDateRef} placeholder='YYYY-MM-DD' />
        </div>
        <div className={classes.actions}>
          <SydButton disabled={processing} variant='ghost' size='lg' onClick={onCancel}>Cancel</SydButton>
          <SydButton
            variant='primary'
            size='lg'
            onClick={(e) => onConfirm(e, {
              reportType: item.reportType,
              asOfDate: asOfDateRef.current?.value || undefined
            })}
            processing={processing}
          >
            Confirm
          </SydButton>
        </div>
      </div>
    </RoundedModal>
  )
}

RunDialog.propTypes = {
  item: PropTypes.shape({
    reportType: PropTypes.string
  }),
  open: PropTypes.bool,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  processing: PropTypes.bool
}

RunDialog.defaultProps = {
  open: false,
  processing: false
}

export default RunDialog
